import React, { Component, createRef } from 'react';
import PopUpReport from './_Report';
import SelectFix from '../../PopUp/SelectFix';
import '../../_css/Report.css';
import { GetCorServicei } from './../../_getjson';
import { MenuItem } from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import CustomDateRangePicker from '../../Components/CustomDatepicker/DateRangePicker'
import getDate from './../../CustomFunction/Getdate'
import Dateconvert from '../../CustomFunction/Date/Dateconvert'

export default class App extends Component {
    state = {
        reportID: "SYM001",
        Parameter: {},
    }

    constructor(props) {
        super(props);
        this.groupData = createRef();
        this.p_brandname = createRef();

        this.p_warehose = createRef();
        this.p_localtion = createRef();



    }
    componentDidMount() {
        //  this.textInput = React.createRef();
        this.groupData.current = "5"
        // this.refs.groupCar.value = '11'

    }

    selectChange = (e) => {
        this.setState({ reportID: e.target.value });
    }

    SelectSetData = (type, data) => {
        switch (type) {
            case "brandname": this.p_brandname.current = data; break;
            case "dataGroupYamaha": this.groupData.current = data; break;
            // case "typeCar": this.refs.groupCar.value = data;break;
        }
    }
    onShowReport = (e) => {
        var dataP = {
            p_datein: typeof this.state.statestartdate === "undefined" ? getDate() : Dateconvert(this.state.statestartdate),
            p_dateto: typeof this.state.stateenddate === "undefined" ? getDate() : Dateconvert(this.state.stateenddate),

            p_groupData: this.groupData.current,
            p_typeCar: this.state.status,
            p_warehose: this.p_warehose.current,
            p_localtion: this.p_localtion.current,
            p_status: this.state.status
        }
        this.setState({ Parameter: dataP });
        setTimeout(() => {
            this.switchReport(); // เปิดรายงานขึ้นมา
        }, 200);
    }

    switchReport = () => {
        console.log("switchReport" + this.state.reportID);
        this.setState({ showReports: !this.state.showReports, tfdocPrint: "" });
    }

    _handleSearch = query => {
        this.setState({ isLoading: true });
        var _url = "";
        var _code = "";
        var _name = "";
        switch (this.state.chkfocus) {
            case "dimension":
                _url = "CSDIMENSION1/getdata?";
                _code = "CODE";
                _name = "MYNAMETH";
                break;

            case "brandname":
                _url = "CSPDSUBGROUP2/getAll?top=500";
                _code = "CODE";
                _name = "MYNAMETH";
                break;
            case "status":
                _url = "CSPDSUBGROUP3/getAll?top=500";
                _code = "CODE";
                _name = "MYNAMETH";
                break;
            case "model":
                _url = "CSPDSUBGROUP4/getAll?top=500";
                _code = "CODE";
                _name = "MYNAMETH";
                break;

            case "color":
                _url = "CSPDSUBGROUP5/getAll?top=1000";
                _code = "CODE";
                _name = "MYNAMETH";
                break;
        }

        return GetCorServicei(_url, "").then(res => {
            console.log(res);
            if (res !== "error") {
                var element = [];
                for (let index = 0; index < res.data.length; index++) {
                    element.push(res.data[index][_code] + " | " + res.data[index][_name]);
                }
                console.log(element);
                this.setState({
                    isLoading: false,
                    options: element
                });
            }
            setTimeout(() => {
                console.log(this.state.options);
            }, 300);
            return "SS";
        });
    };

    _blurinput = () => {
        //  console.log("xxxx" + this.input.value);
        var _txtselect = "";
        var _code = "";
        switch (this.state.chkfocus) {
            case "dimension":
                _txtselect = "" + this.state.selecteddimension;
                _code = _txtselect.split("|");
                this.setState({ dimension: _code[0].trim() });
                // setTimeout(() => {
                //      console.log("_nametxt" + this.state.dimension);
                // }, 100);
                break;
            case "brandname":
                _txtselect = "" + this.state.selectedbrandname;
                _code = _txtselect.split("|");
                this.setState({ brandname: _code[0].trim() });
                // setTimeout(() => {
                //      console.log("_nametxt" + this.state.brandname);
                // }, 100);
                break;
            case "model":
                _txtselect = "" + this.state.selectedmodel;
                _code = _txtselect.split("|");
                this.setState({ model: _code[0].trim() });
                // setTimeout(() => {
                //      console.log("_nametxt" + this.state.dimension);
                // }, 100);
                break;

            case "color":
                _txtselect = "" + this.state.selectedcolor;
                _code = _txtselect.split("|");
                this.setState({ color: _code[0].trim() });
                break;

            case "status":
                _txtselect = "" + this.state.selectedstatus;
                _code = _txtselect.split("|");
                this.setState({ status: _code[0].trim() });
                break;
        }
        // setTimeout(() => {
        //     console.log("dimension" + this.state.dimension);
        // }, 100);
    };


    render() {
        return (
            <div className="report">
                {this.state.showReports ? <PopUpReport close={this.switchReport} reportID={this.state.reportID} Parameter={this.state.Parameter} /> : null}
                <nav class="navbar TopApp">
                    <div class="flex-list">
                        <ul class="nav navbar-nav navbar-left">
                        </ul>
                        <ul class="nav navbar-nav navbar-right" style={{ 'margin-right': '0px' }}>
                            <li>รายงาน YAMAHA</li>
                            <span className="pipe"></span>
                        </ul>
                    </div>
                </nav>
                <div className="gropbox">
                    <div className="row">
                        <div className="miniicon">รายงาน YAMAHA</div>
                    </div>
                </div>
                <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <select onChange={this.selectChange.bind(null)} size="20">
                        <option value="SYM001"> SYM001-รายงานรายการขาย YAMAHA  </option>
                        <option value="SYM002"> SYM002-รายงาน SERVICE-Export  </option>
                        <option value="SYM003"> SYM003-รายงาน Procare  </option>
                        <option disabled style={{ color: '#000000', fontWeight: 700 }} >รายงาน PDI YAMAHA</option>
                        <option value="SYM0041">&nbsp;&nbsp;&nbsp; SYM0041-รายงาน PDI YAMAHA  </option>
                        <option value="SYM0042">&nbsp;&nbsp;&nbsp; SYM0042-รายงาน PDI YAMAHA(มดแดง) </option>
                    </select>
                </div>
                <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6"></div>
                <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class='input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                        <CustomDateRangePicker
                            titleStart={"วันที่เริ่มต้น"}
                            titleEnd={"ถึงวันที่"}
                            startDate={
                                start => { this.setState({ statestartdate: start }) }
                            }
                            endDate={
                                end => { this.setState({ stateenddate: end }) }
                                // e=>console.log(e)
                            } />
                    </div>
                </div>
                <div class="maindiv col-xs-6 col-sm-6 col-md-6 col-lg-6" hidden={this.state.reportID === "SYM001" || this.state.reportID === "SYM0041" || this.state.reportID === "SYM0042" ? false : true}>
                    <div class='input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                        <span class="input-group-addon"> ประเภทรถ </span>
                        {/* <input id="id1" type="text" class="form-control input-custom" ref="groupCar" readOnly/>
                    <span class="input-group-addon txt-img"><SelectFix type={"typeCar"} SelectSetData={this.SelectSetData} /></span>   */}

                        <AsyncTypeahead
                            {...this.state}
                            labelKey="status"
                            onChange={(selectedstatus) => this.setState({ selectedstatus })}
                            onBlur={this._blurinput}
                            onSearch={this._handleSearch}
                            minLength={1}
                            placeholder="สถานะ..."
                            renderMenuItemChildren={(option, props) => (
                                <MenuItem key={option} > {option} </MenuItem>
                            )}
                            onFocus={() => this.setState({ chkfocus: "status" })}
                        />
                    </div>
                </div>
                <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6" hidden={this.state.reportID === "SYM002" ? false : true}>
                    <div class='input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                        <span class="input-group-addon"> เลือกกลุ่ม </span>
                        <input id="id1" type="text" class="form-control input-custom" ref="groupData" readOnly />
                        <span class="input-group-addon txt-img"><SelectFix type={"dataGroupYamaha"} SelectSetData={this.SelectSetData} /></span>
                    </div>
                </div>
                <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6" hidden={this.state.reportID === "SYM003" ? false : true}>
                    <div class='input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                        <span class="input-group-addon"> คลัง </span>
                        <input id="id1" type="text" class="form-control input-custom" ref="p_warehose" />
                        {/* <span class="input-group-addon txt-img"><SelectFix type={"brandname"} SelectSetData={this.SelectSetData}/></span>  */}
                    </div>
                </div>
                <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6" hidden={this.state.reportID === "SYM003" ? false : true}>
                    <div class='input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                        <span class="input-group-addon"> ที่เก็บ </span>
                        <input id="id1" type="text" class="form-control input-custom" ref="p_localtion" />
                    </div>
                </div>

                {/* <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class='input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'  > 
                    <span class="input-group-addon"> สี </span> 
                    <input id="id1" type="text" class="form-control input-custom" ref="p_color"/>
                </div>
            </div>   */}
                <input type="button" onClick={this.onShowReport} value="เรียกดู" />
            </div>
        );
    }
}

